import { BaseDTO } from './basedto';

export class ReassignPackageEngineerDTO {
    CurrentAssignmentIds: number[];
    NewEngineerUserId: Number;
    SourceTypeId: Number;
    PartCategoryId: Number;
    SupplierCode: string;
    SIOCodeId: number;
    PartNumber: string;
    constructor() {
        this.CurrentAssignmentIds = [];
        
    }
}
